// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"5f969ee8","551":"8181d632","851":"9201cf28"}[chunkId] + ".chunk.js";
};